import { render, staticRenderFns } from "./SaveEmailWindow.vue?vue&type=template&id=7f14dbed&scoped=true"
import script from "./SaveEmailWindow.vue?vue&type=script&lang=js"
export * from "./SaveEmailWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f14dbed",
  null
  
)

export default component.exports